// Frozen enums for the pedigree analyzer. Values are stable identifiers;
// user-visible labels are resolved via i18next from the `*LabelKey` fields on
// results, never hardcoded here.
//
// Carrier status is REUSED from the shipped carrier-status module (do not
// redefine) — see PLAN-pedigree-analysis-clinical-insights.md §12.2.
import { CARRIER_STATUS, isCarrierMark } from '../carrier-status/constants';

export { CARRIER_STATUS, isCarrierMark };

// Raw pedigree gender → karyotype-relevant sex token.
export const SEX = Object.freeze({ M: 'M', F: 'F', U: 'U' });
export function toSex(gender) {
  if (gender === 'male') return SEX.M;
  if (gender === 'female') return SEX.F;
  return SEX.U;
}

export const CONFIDENCE = Object.freeze({
  strong: 'strong',
  moderate: 'moderate',
  weak: 'weak',
  ruledOut: 'ruled_out',
  none: 'none'
});

// Mendelian / non-Mendelian inheritance patterns.
export const PATTERN = Object.freeze({
  AD: 'pattern.autosomal_dominant',
  AR: 'pattern.autosomal_recessive',
  XLD: 'pattern.x_linked_dominant',
  XLR: 'pattern.x_linked_recessive',
  MT: 'pattern.mitochondrial',
  YL: 'pattern.y_linked'
});

export const ROLE = Object.freeze({
  proband: 'proband',
  affected: 'affected',
  obligateCarrier: 'obligate_carrier',
  testedCarrier: 'tested_carrier',
  reportedCarrier: 'reported_carrier',
  // Carrier with no stated basis (provenance unspecified).
  carrier: 'carrier',
  cascadeCandidate: 'cascade_candidate',
  unaffectedAtRisk: 'unaffected_at_risk_relative',
  unaffected: 'unaffected',
  unknown: 'unknown'
});

export const ALERT_KIND = Object.freeze({
  variantConflict: 'variant_conflict',
  dataGap: 'data_gap',
  reducedPenetrance: 'reduced_penetrance_flag',
  consanguinity: 'consanguinity'
});

export const RECOMMENDED_ACTION = Object.freeze({
  targetedTest: 'targeted_test',
  panelTest: 'panel_test',
  counsellingFirst: 'counselling_first',
  defer: 'defer'
});
